import { Add } from "@mui/icons-material";
import { Box, Button, InputAdornment, OutlinedInput, Stack, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import NamePage from "src/components/shared/NamePage";
import SearchFilterComp from "src/components/shared/SearchFilterComp";
import TabComp from "src/components/shared/TabComp";
import { WAREHOUSE_MANAGEMENT_TYPE } from "src/constant";
import useAppGlobal from "src/context/useAppGlobal";
import useAuthGlobal from "src/context/useAuthGlobal";
import useQueryParams from "src/hooks/useQueryParams";
import useResetParamsOnTabChange from "src/hooks/useResetParamsOnTabChange";
import InventoryOutTable from "./inventory-out";
import TempExport from "./inventory-out/TempExport";
import InventoryStatistic from "./InventoryStaticstic";
import DateRangePicker from "src/components/shared/DateRangePicker";
import WarehouseFilter from "./components/WarehouseFilter";
import { PERMISSIONS, useRoleCheck } from "src/hooks/permission/permission";
import SelectComp from "src/components/shared/SelectComp";

const tabs = [
  {
    id: WAREHOUSE_MANAGEMENT_TYPE.HISTORY_OUT,
    name: "Lịch sử xuất kho",
  },
  {
    id: WAREHOUSE_MANAGEMENT_TYPE.INVENTORY_OUT_PENDING,
    name: "Chờ xuất kho",
  },
  {
    id: WAREHOUSE_MANAGEMENT_TYPE.INVENTORY_OUT_REMOVE,
    name: "Xuất bỏ hàng hoàn",
  },
];
const topbarSearchList = [
  {
    id: 1,
    title: "Mã phiếu xuất",
    value: "innOutCode",
  },
];
export default function WarehouseManagement() {
  const permissionCheck = useRoleCheck();
  const { handleOpenDialog } = useAppGlobal();
  const { userMe } = useAuthGlobal();
  const [option, setOption] = useQueryParams();
  const [keyword, setKeyword] = useState();
  const [searchBy, setSearchBy] = useState();
  const [date, setDate] = useState();
  const [paramsQuery, setParamsQuery] = useState();
  const [value, setValue] = useState();

  const currentTab = tabs.find((tab) => tab.id === option?.tab);
  const subName = currentTab?.name || "Xuất chuyển/kho";

  useResetParamsOnTabChange(option?.tab, setParamsQuery);

  useEffect(() => {
    setOption({
      ...option,
      warehouse: userMe?.currentWarehouse?._id,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userMe?.currentWarehouse?._id]);

  const handleExportProd = () => {
    handleOpenDialog({
      size: "xl",
      content: <TempExport />,
    });
  };

  return (
    <Fragment>
      <NamePage
        name="Quản lý Kho"
        subName={subName}
      />
      <InventoryStatistic whouseId={userMe?.currentWarehouse?._id} />

      <Box
        mt="12px"
        display="flex"
        justifyContent="space-between"
      >
        <Button
          disabled={!permissionCheck([PERMISSIONS.CREATE_WAREHOUSETRANSFEREXPORT_ALL, PERMISSIONS.CREATE_WAREHOUSETRANSFEREXPORT_OWN])}
          startIcon={<Add />}
          onClick={handleExportProd}
          variant="contained"
          sx={{ whiteSpace: "nowrap" }}
        >
          Tạo lệnh xuất Kho
        </Button>
      </Box>

      <Stack
        gap={1.5}
        mb={1.5}
      >
        <TabComp tabs={tabs} />
        <Box
          display="flex"
          alignItems="center"
          gap="6px"
          justifyContent="space-between"
        >
          <Box
            display="flex"
            gap="6px"
            alignItems="flex-start"
          >
            <SearchFilterComp
              getSearchKeyword={setKeyword}
              getSelectKeyword={setSearchBy}
              selectList={topbarSearchList}
              placeholder="Nhập mã phiếu xuất..."
            />
          </Box>
          <Box sx={{ display: "flex", gap: "12px" }}>
            {permissionCheck([PERMISSIONS.VIEW_SYSTEM_ALL, PERMISSIONS.VIEW_SYSTEM_OWN]) && (
              <Box sx={{ maxWidth: "180px" }}>
                <SelectComp
                  input={
                    <OutlinedInput
                      startAdornment={
                        <InputAdornment position="start">
                          <Typography
                            fontWeight="bold"
                            sx={{
                              borderRight: "1px solid var(--grey)",
                              pr: "12px",
                              color: "var(--black)",
                              fontSize: "12px",
                            }}
                          >
                            Kho
                          </Typography>
                        </InputAdornment>
                      }
                    />
                  }
                  userMe={userMe}
                  value={value}
                  setValue={setValue}
                  item={{ path: "/api/v1/warehouses", params: { limit: 100, skip: 0 } }}
                />
              </Box>
            )}

            <DateRangePicker
              value={date ?? { fromDate: null, toDate: null }}
              onApply={setDate}
              label="Thời gian Xuất Kho"
            />
            <WarehouseFilter
              variant="inventory-out"
              setParamsQuery={setParamsQuery}
              paramsQuery={paramsQuery}
            />
          </Box>
        </Box>
      </Stack>

      <InventoryOutTable
        warehouseId={value}
        date={date}
        topbarSearchList={topbarSearchList}
        keyword={keyword}
        searchBy={searchBy}
        paramsQuery={paramsQuery}
      />
    </Fragment>
  );
}
